// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking')
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all')
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey')
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post')
  },
  cotizaciones: {
    root: path(ROOTS_DASHBOARD, '/cotizaciones'),
    new: path(ROOTS_DASHBOARD, '/cotizaciones/new'),
    cotenvio: path(ROOTS_DASHBOARD, '/cotizaciones/nuevoenvio'),
    hugo: path(ROOTS_DASHBOARD, '/cotizaciones/administracion'),
    userList: path(ROOTS_DASHBOARD, '/cotizaciones/users'),
    cart: path(ROOTS_DASHBOARD, '/cotizaciones/cart'),
    wallet: path(ROOTS_DASHBOARD, '/cotizaciones/wallet'),
    empaque: path(ROOTS_DASHBOARD, '/cotizaciones/empaque')
  },

  funcUsers: {
    funcionesUser: path(ROOTS_DASHBOARD, '/funcionesUser')
  },

  administrativos: {
    userList: path(ROOTS_DASHBOARD, '/administrativos/users'),
    licenciatarios: path(ROOTS_DASHBOARD, '/administrativos/licenciatarios')
  },
  paquetes: {
    envios: path(ROOTS_DASHBOARD, '/paquetes/envios'),
    productos: path(ROOTS_DASHBOARD, '/paquetes/productos'),
    pickup: path(ROOTS_DASHBOARD, '/paquetes/pickup'),
    recoleccion: path(ROOTS_DASHBOARD, '/paquetes/recoleccion'),
    transaccion: path(ROOTS_DASHBOARD, '/paquetes/transacciones')
  },
  servicios: {
    root: path(ROOTS_DASHBOARD, '/servicios'),
    licenciatarios: path(ROOTS_DASHBOARD, '/servicios/licenciatarios'),
    clienteCorp: path(ROOTS_DASHBOARD, '/servicios/cliente_corporativo'),
    puntos: path(ROOTS_DASHBOARD, '/servicios/puntos'),
    cajeros: path(ROOTS_DASHBOARD, '/servicios/cajeros'),
    recargas: path(ROOTS_DASHBOARD, '/servicios/pagos-recargas'),
    servicios: path(ROOTS_DASHBOARD, '/servicios/pagos-servicios'),
    serviciosRecargas: path(ROOTS_DASHBOARD, '/servicios/serviciosRecargas')
  },
  olimpo: {
    olimpo: path(ROOTS_DASHBOARD, '/olimpo'),
    olimpoReports: path(ROOTS_DASHBOARD, '/olimpo/reports')
  },
  licenciatarios: {
    dashboard_corporativo: path(ROOTS_DASHBOARD, '/licenciatarios/dashboard_corporativo'),
    caja: path(ROOTS_DASHBOARD, '/licenciatarios/caja'),
    tickets: path(ROOTS_DASHBOARD, '/licenciatarios/mis_tickets'),
    asignedUsers: path(ROOTS_DASHBOARD, '/licenciatarios/asigned_users')
  },
  crece: {
    main: path(ROOTS_DASHBOARD, '/crece/main'),
    sucursal: path(ROOTS_DASHBOARD, '/crece/sucursal'),
    repartos: path(ROOTS_DASHBOARD, '/crece/repartos')
  },

  locker: {
    admin: path(ROOTS_DASHBOARD, '/administracion_lockers'),
    operationUser: path(ROOTS_DASHBOARD, '/locker_operation_user'),
    regRepartidor: path(ROOTS_DASHBOARD, '/locker_repartidor_reg')
  }
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
